import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';

import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c(VCombobox, {
    class: _vm.required ? "required" : "",
    attrs: {
      items: _vm.warehouses,
      "item-text": "name",
      "item-value": "id_warehouse",
      label: _vm.label,
      "hide-details": "auto",
      rules: _vm.rules,
      clearable: _vm.clearable,
      disabled: _vm.disabled,
      "hide-selected": _vm.hideSelected
    },
    on: {
      input: _vm.changeWarehouse
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c("div", {
          attrs: {
            "data-cy": "warehouse-select-component-name"
          }
        }, [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : item.name) + " "), item.defaultDepartures.length ? _c("span", {
          staticClass: "default-continent-departure text-smaller"
        }, [_vm._v(" - Default departure for " + _vm._s(_vm.getContinentNameFromIso(item)) + " ")]) : _vm._e(), item.deleted ? _c("span", {
          staticClass: "ml-1"
        }, [_vm._v("(deleted)")]) : _vm._e()]), _c(VSpacer), _c(VListItemAction, [_c("div", {
          staticClass: "list-item-actions"
        }, [_c(VBtn, {
          attrs: {
            icon: ""
          },
          on: {
            click: function click($event) {
              $event.stopPropagation();
              return _vm.openEditWarehousePopin(item);
            }
          }
        }, [_c(VIcon, [_vm._v("mdi-pencil")])], 1)], 1)])];
      }
    }, _vm.warehouses.length ? {
      key: "append-item",
      fn: function fn() {
        return [_c(VListItem, {
          on: {
            click: function click($event) {
              $event.stopPropagation();
              return _vm.openNewWarehousePopin.apply(null, arguments);
            }
          }
        }, [_c(VIcon, {
          attrs: {
            dark: ""
          }
        }, [_vm._v("mdi-plus")]), _vm._v(" New warehouse ")], 1)];
      },
      proxy: true
    } : null, !_vm.warehouses.length ? {
      key: "no-data",
      fn: function fn() {
        return [_c(VListItem, {
          on: {
            click: function click($event) {
              $event.stopPropagation();
              return _vm.openNewWarehousePopin.apply(null, arguments);
            }
          }
        }, [_c(VIcon, {
          attrs: {
            dark: ""
          }
        }, [_vm._v("mdi-plus")]), _vm._v(" New warehouse ")], 1)];
      },
      proxy: true
    } : null, {
      key: "selection",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [item.id_warehouse ? _c("div", [_vm._v(_vm._s(item.name))]) : _vm._e()];
      }
    }, {
      key: "append-outer",
      fn: function fn() {
        return [_c(VIcon, {
          attrs: {
            small: ""
          },
          on: {
            click: _vm.openNewWarehousePopin
          }
        }, [_vm._v("fa-plus")])];
      },
      proxy: true
    }], null, true),
    model: {
      value: _vm.model,
      callback: function callback($$v) {
        _vm.model = $$v;
      },
      expression: "model"
    }
  }), _vm.displayAddressBelow && _vm.model ? _c("WarehouseComponent", {
    staticClass: "mt-4",
    attrs: {
      baseModel: _vm.model,
      stockType: "Stock",
      readOnlyMark: true,
      listCountries: _vm.countries,
      listStates: _vm.states,
      isInboundForced: _vm.isInboundForced
    }
  }) : _vm._e(), _vm.warehousePopinShown ? _c("WarehousePopin", {
    ref: "warehousePopin",
    attrs: {
      listCountries: _vm.countries,
      listStates: _vm.states,
      isInboundForced: _vm.isInboundForced,
      stockType: "Stock"
    },
    on: {
      closed: _vm.closeWarehousePopin
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };